import {
  Component,
  inject,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { BaseService } from '../services/base.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { take, takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { Currencies } from '../interfaces/currencies';
import { HeaderData, User } from '../interfaces/header-data';
import { LocalStorageService } from '../services/local-storage.service';
import { InfoMessage } from '../interfaces/info-message';
import * as moment from 'moment/moment';
import { OrdersForPayData } from '../interfaces/orders-for-pay';
import { Areas } from '../interfaces/areas';
import { Delivery } from '../interfaces/delivery';
import { AdminsRequisites } from '../interfaces/contacts';
import { HeaderService } from '../services/header.service';
import { ModalWholesalersComponent } from './modal-wholesalers/modal-wholesalers.component';
import { ModalSupplierComponent } from './modal-supplier/modal-supplier.component';
import { ModalAboutUsComponent } from './modal-about-us/modal-about-us.component';
import { ModalConditionsInformationComponent } from './modal-conditions-information/modal-conditions-information.component';
import { ModalOfertaComponent } from './modal-oferta/modal-oferta.component';
import { ModalOfertaCookieComponent } from './modal-oferta-cookie/modal-oferta-cookie.component';
import { ModalMeinPositionComponent } from './modal-mein-position/modal-mein-position.component';
import { ModalCurrenciesComponent } from './modal-currencies/modal-currencies.component';
import { ModalContactsComponent } from './modal-contacts/modal-contacts.component';
import { ModalReturnsComponent } from './modal-returns/modal-returns.component';
import { ModalReturnsInformationComponent } from './modal-returns-information/modal-returns-information.component';
import { ModalExpectedReceiptGoodsComponent } from './modal-expected-receipt-goods/modal-expected-receipt-goods.component';
import { ModalReceiptsComponent } from './modal-receipts/modal-receipts.component';
import { ModalCardsComponent } from './modal-cards/modal-cards.component';
import { ModalPaymentComponent } from './modal-payment/modal-payment.component';
import { ModalPaymentSuccessComponent } from './modal-payment-success/modal-payment-success.component';
import { ModalHistoryComponent } from './modal-history/modal-history.component';
import { ModalOrdersHistoryNewComponent } from './modal-orders-history-new/modal-orders-history-new.component';
import { ModalMessageComponent } from './modal-message/modal-message.component';
import { ModalDeliveryComponent } from './modal-delivery/modal-delivery.component';
import { AccountSearch } from '../interfaces/account-search';
import { LoaderService } from '../services/loader.service';
import * as packageData from '../../../package.json';
import { ErrorHandlerService } from '../services/error-handler.service';
import { Store } from '@ngrx/store';
import { ModalApiInstructionComponent } from './modal-api-instruction/modal-api-instruction.component';
import { setIncludePartnersStore } from "../store/include-partners/include-partners.action";
import {Organization} from "../interfaces/organization";
import {OrganizationsService} from "../services/organizations.service";
import {removeRepeatedBrand} from "../shared/brand-name";
import {AssistantService} from "../services/assistant.service";

/** Ключ у sessionStorage: коли востаннє перезавантажували сторінку через розбіжність версій */
const VERSION_RELOAD_MARK_KEY = 'header_version_reload_at';
/** Якщо після перезавантаження версія не зійшлась (package.json залито, а збірка ще не готова
 *  або впала) - не перезавантажуємо частіше, ніж раз на 5 хвилин, інакше вкладка крутиться по колу */
const VERSION_RELOAD_COOLDOWN_MS = 300000;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent extends BaseService implements OnDestroy, OnInit {
  @ViewChild(ModalWholesalersComponent) modalWholesalersComponentRef: ModalWholesalersComponent;
  @ViewChild(ModalSupplierComponent) modalSupplierComponentRef: ModalSupplierComponent;
  @ViewChild(ModalAboutUsComponent) modalAboutUsComponentRef: ModalAboutUsComponent;
  @ViewChild(ModalConditionsInformationComponent) modalConditionsInformationComponentRef: ModalConditionsInformationComponent;
  @ViewChild(ModalOfertaComponent) modalOfertaComponentRef: ModalOfertaComponent;
  @ViewChild(ModalOfertaCookieComponent) modalOfertaCookieComponentRef: ModalOfertaCookieComponent;
  @ViewChild(ModalMeinPositionComponent) modalMeinPositionComponentRef: ModalMeinPositionComponent;
  @ViewChild(ModalCurrenciesComponent) modalCurrenciesComponentRef: ModalCurrenciesComponent;
  @ViewChild(ModalContactsComponent) modalContactsComponentRef: ModalContactsComponent;
  @ViewChild(ModalReturnsComponent) modalReturnsComponentRef: ModalReturnsComponent;
  @ViewChild(ModalReturnsInformationComponent) modalReturnsInformationComponent: ModalReturnsInformationComponent;
  @ViewChild(ModalExpectedReceiptGoodsComponent) modalExpectedReceiptGoodsComponentRef: ModalExpectedReceiptGoodsComponent;
  @ViewChild(ModalReceiptsComponent) modalReceiptsComponentRef: ModalReceiptsComponent;
  @ViewChild(ModalCardsComponent) modalCardsComponentRef: ModalCardsComponent;
  @ViewChild(ModalPaymentComponent) modalPaymentComponentRef: ModalPaymentComponent;
  @ViewChild(ModalPaymentSuccessComponent) modalPaymentSuccessComponentRef: ModalPaymentSuccessComponent;
  @ViewChild(ModalHistoryComponent) modalHistoryComponentRef: ModalHistoryComponent;
  @ViewChild(ModalOrdersHistoryNewComponent) modalOrdersHistoryNewComponentRef: ModalOrdersHistoryNewComponent;
  @ViewChild(ModalMessageComponent) modalMessageComponentRef: ModalMessageComponent;
  @ViewChild(ModalDeliveryComponent) modalDeliveryComponentRef: ModalDeliveryComponent;
  @ViewChild(ModalApiInstructionComponent) modalApiInstructionComponentRef: ModalApiInstructionComponent;

  @Input() dataRouteSubject: Subscription;

  private router = inject(Router);
  private http = inject(HttpClient);
  private localStorage = inject(LocalStorageService);
  public headerService = inject(HeaderService);
  public activatedRoute = inject(ActivatedRoute);
  public loaderService = inject(LoaderService);
  private errorHandlerService = inject(ErrorHandlerService);
  private store: Store<{ haveGoodsStore: boolean; includePartnersStore: boolean; }> = inject(Store);
  private organizationsService = inject(OrganizationsService);
  private assistantService = inject(AssistantService);

  private packageData: any = packageData;
  private versionReloadTimer;

  public isDestroyed: Subject<boolean> = new Subject();
  public topSearchString: string = '';
  public isShowListCurrencies: boolean = false;
  public getCurrencies: Currencies[];
  public isDarkBackground: boolean = false;
  public isAccountMenuShow: boolean = false;
  public isModalPaymentShow: boolean = false;
  public isModalCardsShow: boolean = false;
  public currencies_id: any;
  public currencies: Currencies;
  public infoMessage: InfoMessage;
  public infoMessageCount: number = 0;
  public infoMessageList = [];
  public receiptsList = [];
  public waitingGoods = [];
  public user: User;
  public cards;
  public areas: Areas[];
  public delivery: Delivery[];
  public ordersForPay: OrdersForPayData[];
  public payment: {
    pay_card: string;
    pay_card_error: boolean;
    pay_summa: string;
    pay_summa_error: boolean;
    pay_currency: string;
    comment: string;
    pay_comment_error: boolean;
    send_pay_notify: boolean;
    choused_key: string;
    choused_key_error: boolean;
  } = {
    pay_card: '',
    pay_card_error: false,
    pay_summa: '',
    pay_summa_error: false,
    pay_currency: '1',
    comment: '',
    pay_comment_error: false,
    send_pay_notify: false,
    choused_key: '',
    choused_key_error: false,
  };
  public admins_requisites: AdminsRequisites[];
  public contacts_drivers: string = '';
  public exchangeRatesEUR;
  public exchangeRatesUSD;
  public currencySubscribe;
  public searchTimer;
  private searchSubscription: Subscription;
  public isShowMenu: boolean = true;
  public isOpenInputSearch: boolean = false;
  public sessionSearchGoods;
  public currentYear: Number;
  public isModalOrdersHistoryNewShow: boolean = false;
  public rebuildHeaderDataSubscribe;
  public pageType = 0;
  public urlParams = {
    haveGoods: 0,
    searchMode: 'default',
    search: '',
    liters: '',
    viscosity: '',
    approvals: '',
    class_api: '',
    class_acea: '',
    class_ilsac: '',
    class_jaso: '',
    composition: '',
  };
  public allowCurlConnect: boolean;
  public isPriceMenuOpen: boolean = false;
  public isSearchModeOpen: boolean = false;
  public activeOrganization: Organization;
  public isOrganizationsLoaded: boolean = false;

  get searchPlaceholder(): string {
    return this.urlParams.searchMode === 'ai'
      ? 'Пошук по назві товару'
      : 'пошук по: бренд, артикул, найменування';
  }

  get searchModeLabel(): string {
    switch (this.urlParams.searchMode) {
      case 'exact':
        return 'Точне співпадіння';
      case 'ai':
        return 'AI';
      default:
        return 'Стандартний';
    }
  }

  constructor() {
    super();
    this.currentYear = moment().year();
  }

  ngOnInit() {
    this.currencies_id = this.localStorage.get('currencies');
    if (this.currencies_id === null) {
      this.localStorage.set('currencies', '3');
      this.currencies_id = '3';
    }

    this.currencySubscribe = this.headerService.currency.subscribe(() => {
      this.getData();
    });

    this.activatedRoute.queryParams.subscribe((params: any) => {
      if (params.search) {
        this.urlParams.search = params.search;
      } else {
        this.urlParams.search = '';
      }

      if (params.searchMode) {
        this.urlParams.searchMode = params.searchMode;
      } else {
        const saveMode = this.localStorage.get('searchMode');
        this.urlParams.searchMode = saveMode || 'default';
      }

      if (params.haveGoods) {
        this.urlParams.haveGoods = params.haveGoods;
      } else {
        // На /good, /basket, /favorites параметра в URL немає: беремо фільтр зі store, як goToMainPage(),
        // інакше пошук з шапки йшов з haveGoods=0 і вимикав у каталозі «Наявність товару»
        this.store.select('haveGoodsStore')
          .pipe(take(1))
          .subscribe((haveGoodsVal) => {
            this.urlParams.haveGoods = haveGoodsVal ? 1 : 0;
          });
      }

      for (const key of ['liters', 'viscosity', 'approvals', 'class_api', 'class_acea', 'class_ilsac', 'class_jaso', 'composition']) {
        if (params[key]) {
          this.urlParams[key] = params[key];
        } else {
          this.urlParams[key] = '';
        }
      }
    });

    this.dataRouteSubject = this.activatedRoute.data.subscribe((data) => {
      this.pageType = data['type'];
    });

    this.rebuildHeaderDataSubscribe =
      this.headerService.rebuildHeaderData.subscribe(() => {
        this.getData();
      });

    this.organizationsService.organizations$
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((organizations: Organization[]) => {
        if (!organizations || !organizations.length) {
          return;
        }

        this.activeOrganization = organizations.find((org) => org.is_active === '1' || org.is_active === true);
        this.isOrganizationsLoaded = true;

        if (this.activeOrganization && this.activeOrganization.type !== 'fiz' && this.localStorage.get('currencies') !== '1') {
          this.localStorage.set('currencies', '1');
          this.headerService.currency.next('1');
        }
      });

    this.organizationsService.getOrganizations();
  }

  getData() {
    this.http
      .get(this.apiRoot + 'header/data')
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: HeaderData) => {
        this.currencies_id = this.localStorage.get('currencies');
        this.getCurrencies = Object.values(data.data.currencies);
        this.cards = Object.values(data.data.cards);
        this.user = data.data.user;

        this.allowCurlConnect = data.data.user.allow_curl_connect === '1';

        if (data.data.version !== this.packageData.version) {
          this.errorHandlerService.handleError({
            message: `Версии не совпадают: серверная версия ${data.data.version}, клиентская версия ${this.packageData.version}`,
          });
          const lastReloadAt = Number(sessionStorage.getItem(VERSION_RELOAD_MARK_KEY)) || 0;

          // один таймер на сторінку: getData викликається повторно (rebuildHeaderData)
          if (!this.versionReloadTimer && Date.now() - lastReloadAt >= VERSION_RELOAD_COOLDOWN_MS) {
            this.versionReloadTimer = setTimeout(() => {
              sessionStorage.setItem(VERSION_RELOAD_MARK_KEY, String(Date.now()));
              window.location.reload();
            }, 30000);
          }
        }

        this.currencies = this.getCurrencies.find(
          (el) => el.id == this.currencies_id,
        );
        this.headerService.userData.next(this.user);
        if (this.cards && this.cards.length > 0) {
          for (let card of this.cards) {
            if (card.comment) {
              card.comment = card.comment.replace(
                /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
                '$1 <br> $2',
              );
            }
          }
        }

        this.infoMessageCount = data.data.info_message_count;

        if (data.data.surveyed !== 2) {
          this.loaderService.clearRequest = true;

          this.router.navigate(['survey']);
        } else if (data.data.has_new_polls) {
          this.router.navigate(['polls']);
        } else if (this.localStorage.get('delivery_id') === null) {
          this.getDeliveries();
        } else if (data.data.has_new_info_message) {
          setTimeout(() => {
            this.getNewMessage();
          }, 500);
        }

        this.exchangeRatesEUR = this.getCurrencies.find(
          (element) => element.id == 3,
        ).rate;

        this.exchangeRatesUSD = this.getCurrencies.find(
          (element) => element.id == 2,
        ).rate;

        this.exchangeRatesUSD = (
          this.exchangeRatesEUR / this.exchangeRatesUSD
        ).toFixed(3);
      });
  }

  goToMainPage() {
    this.store.select('haveGoodsStore')
      .pipe(take(1))
      .subscribe((haveGoodsVal) => {
        const haveGoods = haveGoodsVal ? 1 : 0;

        this.store.dispatch(setIncludePartnersStore({ value: true }));
        this.router.navigate(['account'], {
          queryParams: { haveGoods, includePartners: 1 },
        });
      });
  }

  onSearchModeChange() {
    this.localStorage.set('searchMode', this.urlParams.searchMode);

    this.router.navigate([], { queryParams: this.urlParams });
  }

  toggleSearchModeDropdown() {
    this.isSearchModeOpen = !this.isSearchModeOpen;
  }

  closeSearchModeDropdown() {
    this.isSearchModeOpen = false;
  }

  selectSearchMode(mode: string) {
    this.urlParams.searchMode = mode;
    this.isSearchModeOpen = false;
    this.onSearchModeChange();
  }

  closeOrders() {
    if (this.pageType === 1) {
      this.isAccountMenuShow = false;
      this.isDarkBackground = false;
    }
  }

  getPrice() {
    const delivery_id = this.localStorage.get('delivery_id');
    const currency = this.localStorage.get('currencies');
    window.open(
      this.apiRoot +
        `price/data?currency=${currency}&delivery_id=${delivery_id}`,
      '_blank',
    );
  }

  openPriceCategoryMenu(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.isPriceMenuOpen = !this.isPriceMenuOpen;
  }

  getPriceCategoryPartner(category: 'oils' | 'filters' | 'parts') {
    const delivery_id = this.localStorage.get('delivery_id');
    const currency = this.localStorage.get('currencies');

    window.open(
      this.apiRoot +
        `price/price_partner?currency=${currency}&delivery_id=${delivery_id}&category=${category}`,
      '_blank',
    );

    this.isPriceMenuOpen = false;
  }

  openModalHistory() {
    this.modalHistoryComponentRef.openModalHistoryShow();
  }

  openModalDelivery() {
    this.closeModal();
    this.modalOrdersHistoryNewComponentRef.openModalDeliveryShow();
  }

  getDeliveries() {
    this.modalDeliveryComponentRef.getDeliveriesShow();
  }

  getNewMessage() {
    this.modalMessageComponentRef.getNewMessageShow();
  }

  // Відміняє відкладений і вже відправлений запит підказок: інакше відповідь, що прийшла
  // після Enter/хрестика/вибору товару, знову відкривала список поверх результатів,
  // а відповідь на старий рядок могла прийти пізніше за новий і затерти підказки
  cancelSessionSearch() {
    clearTimeout(this.searchTimer);

    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
      this.searchSubscription = null;
    }
  }

  sessionSearchString() {
    this.cancelSessionSearch();

    if (this.urlParams.searchMode === 'ai') {
      this.sessionSearchGoods = [];
      return;
    }

    this.searchTimer = setTimeout(() => {
      this.searchSubscription = this.http
        .post(this.apiRoot + 'accounts/search_goods', {
          search_string: this.urlParams.search,
          search_mode: this.urlParams.searchMode,
        })
        .pipe(takeUntil(this.isDestroyed))
        .subscribe((data: AccountSearch) => {
          // На помилці пошуку бек віддає {success: false, error} без data - не падаємо, а ховаємо підказки
          this.sessionSearchGoods = Array.isArray(data?.data) ? data.data : [];
          for (let goods of this.sessionSearchGoods) {
            goods.name = goods.name.replaceAll('&nbsp;', ' ');
            // назву з брендом склеює індекс пошуку, бренду окремо немає (#855)
            goods.name = removeRepeatedBrand(goods.name);
          }
        });
    }, 500);
  }

  searchKeyDown(event) {
    if (event.key === 'Enter') {
      this.cancelSessionSearch();
      this.router.navigate([`account`], { queryParams: this.urlParams });

      this.urlParams.search = '';
      this.sessionSearchGoods = [];
      this.isOpenInputSearch = false;
      this.isDarkBackground = false;
    }
  }

  searchGood() {
    this.router.navigate([`account`], { queryParams: this.urlParams });
    this.isOpenInputSearch = false;
    this.isDarkBackground = false;
  }

  crossClears() {
    this.cancelSessionSearch();
    this.urlParams.search = '';
    this.router.navigate([`account`], { queryParams: this.urlParams });
    this.sessionSearchGoods = [];
    this.isOpenInputSearch = false;
    this.isDarkBackground = false;
  }

  hideSearchHelp() {
    this.cancelSessionSearch();

    setTimeout(() => {
      this.sessionSearchGoods = [];
    }, 300);
  }

  crossClearsSearchField() {
    this.urlParams.search = '';
    this.router.navigate([`account`], { queryParams: this.urlParams });
  }

  selectGoods(good_id, search) {
    this.cancelSessionSearch();
    this.urlParams.search = '';

    this.router.navigate([`good`, good_id]);
  }

  closeSelectGoods() {
    this.isOpenInputSearch = false;
    this.isDarkBackground = false;
  }

  openInputSearch() {
    this.isOpenInputSearch = true;
    this.isDarkBackground = true;
  }

  onCurrencies() {
    this.isShowListCurrencies = !this.isShowListCurrencies;
  }

  setCurrency(id) {
    this.localStorage.set('currencies', id);
    this.currencies_id = id;
    this.currencies = this.getCurrencies.find(
      (el) => el.id == this.currencies_id,
    );
    this.headerService.currency.next(id);
  }

  openModalReceipts() {
    this.closeModal();
    this.modalReceiptsComponentRef.openModalReceiptsShow();
  }

  modalInfoMessageConfirm() {
    this.getData();
  }

  showAccountMenu() {
    this.isAccountMenuShow = true;
    this.isDarkBackground = true;
  }

  openModalWaitingGoods() {
    this.closeModal();
    this.modalExpectedReceiptGoodsComponentRef.openModalWaitingGoodsShow();
  }

  openModalRequisites() {
    this.closeModal();
    this.modalCardsComponentRef.openModalRequisitesShow();
  }

  modalPaymentChange() {
    this.modalPaymentComponentRef.modalPaymentShow();
  }

  modalSendPaymentChange() {
    this.modalPaymentSuccessComponentRef.modalSuccessShow();
  }

  openModalReturns() {
    this.closeModal();
    this.modalReturnsComponentRef.openModalReturnsShow();
    this.isAccountMenuShow = false;
  }

  openModalInstructionApi() {
    this.closeModal();
    this.modalApiInstructionComponentRef.modalApiInstructionShow();
  }

  modalReturnsInformationChange() {
    this.modalReturnsInformationComponent.openModalReturnsInformationShow();
  }

  openModalContacts() {
    this.closeModal();
    this.modalContactsComponentRef.openModalContactsShow();
  }

  modalCurrencies() {
    this.modalCurrenciesComponentRef.modalCurrenciesShow();
  }

  openModalAboutUs() {
    this.closeModal();
    this.modalAboutUsComponentRef.openModalAboutUsShow();
  }

  openModalProvider() {
    this.closeModal();
    this.modalSupplierComponentRef.openModalSupplierShow();
  }

  openModalWholesaler() {
    this.closeModal();
    this.modalWholesalersComponentRef.openModalWholesalerShow();
  }

  openModalTermsOfUse() {
    this.closeModal();
    this.modalConditionsInformationComponentRef.openModalTermsOfUsShow();
  }

  modalOfertaChange() {
    this.closeModal();
    this.modalOfertaComponentRef.openModalOfertaShow();
  }

  modalOfertaCookieChange() {
    this.closeModal();
    this.modalOfertaCookieComponentRef.openModalCookieShow();
  }

  modalMainPositionChange() {
    this.closeModal();
    this.modalMeinPositionComponentRef.openModalMainPositionShow();
  }

  closeModal() {
    this.isModalCardsShow = false;
    this.isModalPaymentShow = false;
    this.isAccountMenuShow = false;
    this.isOpenInputSearch = false;
    this.isModalOrdersHistoryNewShow = false;
    this.isDarkBackground = false;
    this.isPriceMenuOpen = false;
  }

  signOut() {
    this.http
      .get(this.apiRoot + 'auth/signout')
      .pipe(takeUntil(this.isDestroyed))
      .subscribe(() => {
        this.localStorage.delete('delivery_id');
        this.localStorage.delete('currencies');
        // Історію чату помічника наступний у цій вкладці не бачить
        this.assistantService.forget();
        // ...і не отримує вікно помічника відкритим після входу (картка #982)
        this.assistantService.saveOpenState(false);
        // Головна тепер на новому фронтенді (v2) — потрібне повне перезавантаження
        window.location.assign('/');
      });
  }

  ngOnDestroy() {
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
    this.currencySubscribe.unsubscribe();
    this.rebuildHeaderDataSubscribe.unsubscribe();
  }
}
